import axios from 'axios';

import { normalizeEventCode } from '../config/eventsCatalog';

const WORKSHOP_ENDPOINT = process.env.REACT_APP_LEAD_ENDPOINT;

const requestConfig = {
    headers: {
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_AWS_API_GATEWAY_KEY,
    },
    timeout: 8000,
};

function normalizeEmail(raw) {
    return String(raw || '')
        .trim()
        .toLowerCase();
}

/** Drop empty strings and empty checkbox arrays before POST. */
export function sanitizeWorkshopAnswers(answers) {
    if (!answers || typeof answers !== 'object') return {};
    const out = {};
    for (const [key, value] of Object.entries(answers)) {
        if (Array.isArray(value)) {
            const filtered = value.filter((v) => String(v).trim() !== '');
            if (filtered.length > 0) out[key] = filtered;
            continue;
        }
        const s = String(value ?? '').trim();
        if (s !== '') out[key] = s;
    }
    return out;
}

async function postWorkshopPhase(body) {
    if (!WORKSHOP_ENDPOINT) {
        console.warn('REACT_APP_LEAD_ENDPOINT is not set; skipping workshop sync');
        return false;
    }
    try {
        await axios.post(WORKSHOP_ENDPOINT, body, requestConfig);
        return true;
    } catch (err) {
        console.error('EventWorkshopService: request failed', err);
        return false;
    }
}

/**
 * Gate submit — user entered email and valid event code.
 */
export async function reportWorkshopStarted({ email, eventCode, startedAt }) {
    const normalizedEmail = normalizeEmail(email);
    const event_code = normalizeEventCode(eventCode);
    if (!normalizedEmail || !event_code) return false;

    return postWorkshopPhase({
        phase: 'started',
        email: normalizedEmail,
        event_code,
        started_at: startedAt || new Date().toISOString(),
    });
}

/**
 * Last exercise step — workshop finished; include field answers.
 */
export async function reportWorkshopCompleted({
    email,
    eventCode,
    startedAt,
    completedAt,
    answers,
}) {
    const normalizedEmail = normalizeEmail(email);
    const event_code = normalizeEventCode(eventCode);
    if (!normalizedEmail || !event_code) return false;

    return postWorkshopPhase({
        phase: 'completed',
        email: normalizedEmail,
        event_code,
        started_at: startedAt || new Date().toISOString(),
        completed_at: completedAt || new Date().toISOString(),
        answers: sanitizeWorkshopAnswers(answers),
    });
}
